export enum PAYMENT_STATUS { READY_TO_PAY = 'READY_TO_PAY'
                           , PAID = 'PAID'
}
